import { useEffect, useState } from "react";

/**
 * Retorna true quando a viewport é menor ou igual a `breakpoint` (padrão 768px).
 * Substitui o antigo hook removido durante o cleanup.
 */
export function useIsMobile(breakpoint = 768) {
  const getMatches = () =>
    typeof window !== "undefined" && window.matchMedia(`(max-width: ${breakpoint}px)`).matches;

  const [isMobile, setIsMobile] = useState<boolean>(getMatches());

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const listener = () => setIsMobile(media.matches);
    listener();
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [breakpoint]);

  return isMobile;
}
